import { cva, type VariantProps } from "class-variance-authority";
import { clsx } from "clsx";

import { getNameInitials } from "~/utils/get-name-initials";

const avatarContainer = cva(
  "flex items-center justify-center rounded-full bg-gray-200",
  {
    variants: {
      size: {
        sm: "size-10",
        lg: "size-40"
      }
    }
  }
);

const avatarText = cva("font-bold", {
  variants: {
    size: {
      sm: "text-2xl",
      lg: "text-6xl"
    }
  }
});

type AvatarProps = VariantProps<typeof avatarContainer> & {
  name?: string;
  className?: string;
};

export const Avatar = ({ name, className, size = "lg" }: AvatarProps) => {
  const initials = name ? getNameInitials(name) : null;

  return (
    <div className={clsx(avatarContainer({ size }), className)}>
      {initials ? (
        <span className={avatarText({ size })}>{initials}</span>
      ) : null}
    </div>
  );
};
